export const DEDICATED_SERVICE_REQUIRED_EVENT = 'dedicated-service-required'

export const dedicatedOperationName = (operation: { extra_info?: unknown; name?: string; operation_type?: string; id: string }): string => {
  let info = operation.extra_info
  if (typeof info === 'string') {
    try { info = JSON.parse(info) } catch { /* Plain text is also valid in OpenAPI. */ }
  }
  if (info && typeof info === 'object' && 'Server name' in info) {
    const name = (info as Record<string, unknown>)['Server name']
    if (typeof name === 'string' && name) return name
  }
  return operation.name || operation.operation_type || operation.id
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

// Used only for dedicated-server requests; the service marker is independent of the error language.
export const isDedicatedServiceInactiveError = (error: unknown): boolean => {
  if (!isRecord(error)) {
    return false
  }

  const response = isRecord(error.response) ? error.response : null
  const data = response && isRecord(response.data) ? response.data : error

  return data.service === 'None'
}
